import AService from '@/services/AService'

export default class AuthService extends AService {
  async login (email, password, captchaSession, captchaAnswer) {
    const body = {
      email: email && email.trim(),
      password: password && password.trim(),
      captchaSession: captchaSession,
      captchaAnswer: captchaAnswer
    }

    const response = await this.http.post(`${this.baseUrl}/auth/login`, body)
    return response.data
  }
}
